
import React, { useEffect, useState } from 'react';
import { supplierAPI } from '../utils/api';
import '../styles/Suppliers.css';

const SupplierPaymentsModal = ({ supplier, onClose }) => {
  const [payments, setPayments] = useState([]);
  const [creditInfo, setCreditInfo] = useState({ totalPaid: 0, totalCredit: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const [paymentsRes, creditRes] = await Promise.all([
          supplierAPI.getPayments(supplier.id),
          supplierAPI.getCredit(supplier.id)
        ]);
        setPayments(paymentsRes.data || []);
        setCreditInfo(creditRes.data || { totalPaid: 0, totalCredit: 0 });
      } catch (err) {
        setError('Failed to fetch payment info');
      } finally {
        setLoading(false);
      }
    };
    if (supplier?.id) fetchPayments();
  }, [supplier]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Payments & Credits - {supplier.supplierName}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-form">
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : error ? (
            <div className="alert alert-error">{error}</div>
          ) : (
            <>
              <div className="summary-row">
                <div>
                  <strong>Total Paid:</strong> ₹{creditInfo.totalPaid?.toFixed(2) || '0.00'}
                </div>
                <div>
                  <strong>Outstanding Credit:</strong> ₹{creditInfo.totalCredit?.toFixed(2) || '0.00'}
                </div>
              </div>
              <h3>Payment History</h3>
              {payments.length === 0 ? (
                <p>No payments recorded for this supplier.</p>
              ) : (
                <table className="payments-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Mode</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map(payment => (
                      <tr key={payment.id}>
                        <td>{payment.paymentDate ? new Date(payment.paymentDate).toLocaleDateString() : '-'}</td>
                        <td>₹{parseFloat(payment.amount || 0).toFixed(2)}</td>
                        <td>{payment.paymentMode || '-'}</td>
                        <td>{payment.notes || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupplierPaymentsModal;
